module.exports = __webpack_public_path__ + "static/media/sh-loading-gif.fd8fe099.gif";